<template>
    <div class="black-bg">
        <div v-if="isAccountLoaded">
            <div v-if="campaign != null">
                <CampaignPicture
                    class="layout-picture box-picture d-none"
                    imgClass="default"
                    :campaignImage="campaign.pictures"
                ></CampaignPicture>
                <DetailInfo
                    class="layout-info"
                    :lbl="lbl"
                    :campaign="campaign"
                    :isNews="true"
                    :hideCondition="true"
                ></DetailInfo>
                <!-- For Type News *Hide Condition -->
                <DetailAndCondition
                    class="d-none"
                    :lbl="lbl"
                    :campaign="campaign"
                ></DetailAndCondition>
            </div>
        </div>
        <ModalMaster class="d-none" :controller="modalController" />
    </div>
</template>
<script>
//helper
// import Account from "@/helper/AccountHelper.js";
// import Util from "@/helper/Utility.js";
// import ConfigManager from "@/config/ConfigManager.js";
// import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import Mixin from "@/mixin/Mixin";
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import CampaignPicture from "../component/detail/PictureDetail.vue";
import DetailInfo from "../component/detail/DetailInfo.vue";
import DetailAndCondition from "../component/detail/DetailAndCondition.vue";
//controller
import { DetailController } from "../controller/DetailController.js";
import { RedeemController } from "../controller/RedeemController.js";
//service
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";

export default {
    name: "Campaign",
    mixins: [Mixin, AccountMixin, LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        CampaignPicture,
        DetailInfo,
        DetailAndCondition
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),
            // cacheHelper: new CacheHelper(),
            campaign: null
        };
    },
    created: function() {
        // this.initialIsFromLanding();
        this.initialCampaign();
    },
    methods: {
        initialCampaign: function() {
            var campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            this.setupDetailController();
        },

        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        // initialIsFromLanding: function() {
        //     var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
        //     var formLanding = Util.jsonParse(
        //         cacheHelper.getCache("isfromlanding")
        //     );

        //     if (formLanding != null) {
        //         cacheHelper.removeCache("isfromlanding");

        //         if (formLanding.page == "wodd") {
        //             return;
        //         }
        //         var backAmount = formLanding.page == "interface" ? -3 : -2;
        //         history.go(backAmount);
        //     }
        // },
        //#endregion initial

        //#region setup
        setupDetailController: function() {
            this.loadingModal.show();
            this.handleLoading(true);
            this.detailController
                .initial(this.campaignConfig)
                .then(campaign => {
                    this.campaign = campaign;
                    this.redeemController.initial(
                        this.campaign,
                        this.modalController
                    );
                })
                .catch(err => {
                    this.errorResponse(err);
                })
                .finally(() => {
                    this.loadingModal.hide();
                    this.handleLoading(false);
                });
        }
        //#endregion setup
    }
};
</script>
<style lang="scss" scoped>
.black-bg {
    background-color: #000;
}
.box-picture {
    padding: 0 20px;
    .owl-theme .owl-dots .owl-dot.active span {
        background: #f06634;
    }
    .owl-theme .owl-dots .owl-dot span {
        width: 8px;
        height: 8px;
        margin: 5px 2px;
    }
    .owl-theme .owl-nav.disabled + .owl-dots {
        margin-top: 6px;
    }
}
</style>
